<template>
  <session class="page-left-navs">
    <div class="page-left-navs-t" @click="toggleLeftNavExpand"><Icon name="category" /></div>
    <div class="page-left-navs-b" :class="{ clb: pathname === 'register' ||  pathname === 'resetpwd'}">
      <div class="page-left-scrollbar" :class="{ reverse: leftReverse }" v-if="pathname && ![ 'home', 'protocol','register','resetpwd' ].includes(pathname)" @click="Utils.scrollToTop.action">
        <span class="checkmore" :class="{ checkmoreh: langCode != 'zh' }">{{ leftReverse ? LOCAL('backtotop') : LOCAL('scroll') }}</span>
        <Icon name="trial-down" />
      </div>
    </div>
  </session>

  <Transition name="lnfade">
    <section class="page-left-navs-full" v-if="leftNavExpand">
      <div class="page-left-navs-full-inner">
        <div class="bg" />
        <div class="page-left-navs-t">
          <div class="closewrap" @click="toggleLeftNavExpand"><Icon name="close" /></div>
        </div>
        <div class="page-left-navs-b">
          <div class="page-left-navs-bl">
            <div class="page-left-navs-blt">
              <div class="navs">
                <div class="item" v-for="(item, index) in navs" @click="toTagetPage(item)"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.label }}</span></div>
              </div>
              <div class="protocols">
                <div class="item" v-for="(item, index) in protocolEntrances" @click="toTagetPage(item)"><span>{{ item?.label }}</span></div>
              </div>
            </div>
            <div class="page-left-navs-blb">
              <div class="loginwrap" @click="goLogin">
                <Icon name="checkmore white" />
                <span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ LOCAL('login') }}</span>
              </div>
              <span class="copyright">{{ LOCAL('copyRight') }}</span>
            </div>
          </div>
          <div class="page-left-navs-br" :class="{ 'page-left-navs-br-show': leftNavLogoExpand }" v-if="leftNavLogoExpand">
            <img class="logo" src="@/assets/images/logo-en.svg" v-if="!getLocalLangCode() || getLocalLangCode() == 'en'" />
            <img class="logo" src="@/assets/images/logo.svg" v-if="getLocalLangCode() == 'zh'" />
            <img class="logo" src="@/assets/images/logo-jp.svg" v-if="getLocalLangCode() == 'jp'" />
            <img class="logo" src="@/assets/images/logo-kr.svg" v-if="getLocalLangCode() == 'kr'" />
          </div>
        </div>
      </div>
    </section>
  </Transition>
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue';
  import * as Utils from '@/assets/utils';
  import { LOCAL, getLocalLangCode } from '@/assets/lang/index';
  import Icon from '@/components/icon/index.vue';
  import router from '@/router';
  import { useRouter, useRoute } from 'vue-router';
  import EventBus from '@/assets/eventbus';
  const route = useRoute();

  const leftReverse = ref(false);
  const leftReverseInit = () => {
    EventBus.on('global_page_scroll', (top) => {
      leftReverse.value = !!(top > 100)
    });
    // clearTimeout(leftReverseTimer);
    // leftReverseTimer = null;

    // const aboutEl = document.querySelector('.js-page-aboutus');
    // const claimsEl = document.querySelector('js-page-claims');
    // if(!aboutEl) {
    //   leftReverseTimer = setTimeout(() => {
    //     leftReverseInit();
    //   }, 1000);
    //   return;
    // }
    // if(aboutEl) {
    //   aboutEl.addEventListener('scroll', e => {
    //     leftReverse.value = !!(e.target.scrollTop > 100)
    //   })
    // }
  }
  onMounted(() => {
    leftReverseInit();
  })
  
  const pathname = ref('');
  const initPathname = () => {
    pathname.value = route?.name
    //console.log('pathname.value', pathname.value)
  }
  onMounted(() => {
    initPathname();
  });
  watch(() => route, () => {
    initPathname();
  }, { deep: true })

  const langCode = ref('');
  onMounted(() => {
    langCode.value = getLocalLangCode();
  })

  const leftNavExpand = ref(false);
  const leftNavLogoExpand = ref(false);
  const toggleLeftNavExpand = () => {
    if(leftNavExpand.value) {
      leftNavLogoExpand.value = false;
      setTimeout(() => {
        leftNavExpand.value = false
      }, 20);
    }else{
      leftNavExpand.value = true;
      setTimeout(() => {
        leftNavLogoExpand.value = true;
      }, 450);
    }
  }

  const navs = ref([]);
  const protocolEntrances = ref([]);
  const init = () => {
    navs.value = [
      { label: LOCAL('home'), path: '/home' },
      { label: LOCAL('aboutUs'), path: '/aboutus' },
      { label: LOCAL('productService'), path: '/productservice' },
      { label: LOCAL('claims'), path: '/claims' },
      { label: LOCAL('questions'), path: '/questions' },
      { label: LOCAL('contactUs'), path: '/contactus' },
    ];
    protocolEntrances.value = [
      { label: LOCAL('privacyPolicy'), path: '/protocol/private' },
      { label: LOCAL('termsUse'), path: '/protocol/term' }
    ];
  }
  onMounted(() => {
    init()
  });

  const toTagetPage = item => {
    toggleLeftNavExpand();
    router.push(item?.path || '/');
  }

  const toTagetPage2 = item => {
    toggleLeftNavExpand();
    window.location.href = item?.path
  }

  const goLogin = () => {
    toggleLeftNavExpand();
    Utils.loginDialogToggle(true)

  }
</script>

<style scoped lang="less">
  @import "index.less";
</style>
